import React from 'react';
import SingleStoreyA from './SingleStoreyA';
import SchoolN from './SchoolN';

// Preserve L1's approved outlines; new outlines remain subject to teacher glyph QA.
export default function Grade1Letter({ letter }) {
  if (letter === 'a') return <SingleStoreyA />;
  if (letter === 'n') return <SchoolN />;
  if (!['e', 't', 'i', 'l'].includes(letter)) return null;
  return <svg viewBox="0 0 100 100" aria-hidden="true" data-testid={`school-${letter}`} fill="none"
    stroke="currentColor" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round">
    {letter === 'e' ? <path d="M78 50H22C22 34 34 24 50 24C67 24 78 35 78 50M22 50C22 78 58 90 78 71" />
      : letter === 't' ? <path d="M48 14V68Q48 85 68 78M27 39H69" />
      : letter === 'i' ? <><circle cx="50" cy="19" r="5" fill="currentColor" stroke="none" /><path d="M50 39V80" /></>
      : <path d="M50 14V80" />}
  </svg>;
}
